export default __webpack_public_path__ + "static/media/logo_csn_horizontal.ce114e28.svg";